import { i18n } from "@/app/i18n";
import { $message } from "various-ui";

/**@name 数据导出Excel表格 */
export const xlsx = (name: string, names: { key: string; name: string }[], data: any[]) => {
    //* 数据初始化
    const result: string[] = [];
    //* 表头生成
    result.push(names.reduce((result, value) => (result += `${value.name},`), ""));
    //* 表格内容生成
    data.forEach((value) => {
        result.push(names.reduce((r, v) => (r += `${value[v.key] || ""},`), ""));
    });

    //* 下载链接
    const aLink = document.createElement("a");
    //* 下载链接append到文档中
    document.body.appendChild(aLink);
    //* 属性更新
    aLink.href = `data:text/csv;charset=utf-8,\ufeff${encodeURIComponent(result.join("\n"))}`;
    aLink.download = `${name || "导出数据"}.csv`;
    //* 下载
    aLink.click();
    //* 删除下载链接
    document.body.removeChild(aLink);
};

/**@name 文本复制 */
export const copyText = (copy: string) => {
    // 判断浏览器是否支持剪贴板对象
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(copy).then(() => {
            $message.success(i18n.global.t("CopySuccess"));
        });
    } else {
        // 创建text area
        const textArea = document.createElement("textarea");
        textArea.value = copy;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        textArea.remove();
        $message.success(i18n.global.t("CopySuccess"));
    }
};

/**@name 文件下载 */
export const download = (href: string, name?: string) => {
    //* 下载链接
    const aLink = document.createElement("a");
    //* 下载链接append到文档中
    document.body.appendChild(aLink);
    //* 属性更新
    aLink.href = href;
    if (name) {
        aLink.download = name;
    }

    //* 下载
    aLink.click();
    //* 删除下载链接
    document.body.removeChild(aLink);
};
